import { supabase } from "../supabase/client";

export const debugAuthState = async (message?: string, data?: any) => {
  console.group("🔍 Auth State Debugging");
  
  if (message) {
    console.log(`📌 ${message}`, data);
  }
  
  try {
    // Get Supabase session directly to avoid circular dependency
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();
    
    console.log('📊 Current State:', {
      timestamp: new Date().toISOString(),
      supabase: {
        sessionId: session?.user?.id,
        sessionError,
        expiresAt: session?.expires_at ? new Date(session.expires_at * 1000).toISOString() : null
      }
    });
    
    console.log('🗄️ Storage State:');
    const supabaseKeys = Object.keys(localStorage).filter(key => key.includes('supabase'));
    supabaseKeys.forEach(key => {
      try {
        const value = localStorage.getItem(key);
        console.log(`  ${key}:`, value ? JSON.parse(value) : null);
      } catch {
        console.log(`  ${key}: [parse error]`);
      }
    });
    
    try {
      const testKey = "auth-debug-test";
      localStorage.setItem(testKey, "test");
      const testValue = localStorage.getItem(testKey);
      localStorage.removeItem(testKey);
      console.log(`localStorage working: ${testValue === "test" ? "✅ Yes" : "❌ No"}`);
    } catch (e) {
      console.log("❌ localStorage not available:", e);
    }
    
  } catch (error) {
    console.error("Debug error:", error);
  }
  
  console.groupEnd();
  return "Debug complete - check console";
};

export function traceAuthFlow(step: string, data?: any) {
  const trace = {
    step,
    timestamp: new Date().toISOString(),
    data,
    stack: new Error().stack?.split('\n').slice(2, 5).join('\n')
  };
  
  console.log(`🔄 Auth Flow: ${step}`, trace);
  
  // Store in session storage for debugging. sessionStorage is absent outside
  // a live browser environment (SSR, Node test teardown) — never throw here,
  // a debug trace must not kill the caller after the DOM is gone.
  if (typeof sessionStorage === 'undefined') return;
  const traces = JSON.parse(sessionStorage.getItem('auth_traces') || '[]');
  traces.push(trace);
  if (traces.length > 50) traces.shift(); // Keep last 50 traces
  sessionStorage.setItem('auth_traces', JSON.stringify(traces));
}

export function getAuthTraces() {
  if (typeof sessionStorage === 'undefined') return [];
  return JSON.parse(sessionStorage.getItem('auth_traces') || '[]');
}

export function clearAuthData() {
  console.log('🧹 Clearing all auth data...');
  
  const keysToRemove = Object.keys(localStorage).filter(key => 
    key.includes('supabase') || key.includes('auth')
  );
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  sessionStorage.removeItem('auth_traces');
  
  console.log('✅ Auth data cleared');
}
